const ServiceAreaIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.5107 13.6894L39.6842 17.8629L43.8183 13.7287L43.8577 13.6894C46.1807 11.3664 46.1807 7.62596 43.8577 5.34234C41.5347 3.01935 37.7943 3.01935 35.5107 5.34234C35.1957 5.65732 34.9201 6.01168 34.6838 6.36603C33.2664 8.64965 33.5027 11.6814 35.5107 13.6894ZM36.4162 8.17718L37.8337 7.11411L39.6842 5.69669L42.9521 8.13781V12.2719H36.4162V8.17718Z"
        fill="#FF896F"
      />
      <path
        d="M14.4858 24.7533C14.289 25.3439 14.2496 25.9345 14.3677 26.5644C14.4858 27.2338 14.8402 27.8637 15.352 28.3756L17.8719 30.8954L20.3917 28.3756C20.9036 27.8637 21.2186 27.2338 21.3761 26.5644C21.4942 25.9738 21.4548 25.3439 21.2579 24.7533C21.1005 24.2415 20.8248 23.769 20.3917 23.3753C19.683 22.6665 18.7774 22.3516 17.8719 22.3516C16.9663 22.3516 16.0607 22.7059 15.352 23.3753C14.9189 23.769 14.6433 24.2415 14.4858 24.7533Z"
        fill="#002245"
      />
      <path
        d="M44.5664 31.3675C44.3302 31.1313 44.0939 30.9738 43.8183 30.8163C42.4797 30.0289 40.7079 30.2257 39.5267 31.3675C38.1487 32.7456 38.1487 34.9898 39.5267 36.3679L42.0466 38.8877L43.8183 37.116L44.5664 36.3679C45.9445 34.9898 45.9445 32.7456 44.5664 31.3675Z"
        fill="#002245"
      />
      <path
        d="M15.3126 28.3752C14.8007 27.8633 14.4857 27.2334 14.3282 26.564L4.80005 24.2017V38.0609C4.80005 39.872 6.02059 41.4469 7.79237 41.88L15.9031 43.888C16.5331 44.0455 17.1631 44.1243 17.7931 44.1243V30.8557L15.3126 28.3752Z"
        fill="#B0D5F7"
      />
      <path
        d="M39.5268 36.3681C38.1488 34.9901 38.1488 32.7458 39.5268 31.3678C40.6686 30.1866 42.4404 30.0291 43.8184 30.8166V27.3912L30.8254 24.1626V41.3685C31.4554 41.3685 32.1247 41.4472 32.7153 41.6047L40.1174 43.4552C41.9679 43.9277 43.7791 42.5103 43.7791 40.581V37.1162L42.0073 38.888L39.5268 36.3681Z"
        fill="#B0D5F7"
      />
      <path
        d="M15.3127 23.3357C16.0214 22.627 16.927 22.312 17.8326 22.312V8.37405C17.2026 8.37405 16.5333 8.2953 15.9427 8.13781L8.54059 6.28728C6.69007 5.81481 4.87891 7.23224 4.87891 9.1615V22.3514L14.5252 24.7531C14.6433 24.2413 14.919 23.7688 15.3127 23.3357Z"
        fill="#B0D5F7"
      />
      <path
        d="M30.8254 22.3513L43.8184 25.5798V13.7286L39.6843 17.8628L35.5108 13.6893C33.5028 11.6813 33.2665 8.64955 34.684 6.36593L32.7153 5.89345C32.0854 5.73596 31.4554 5.65723 30.8254 5.65723V22.3513Z"
        fill="#B0D5F7"
      />
      <path
        d="M14.4857 24.7533L4.83936 22.3516V24.1627L14.3676 26.5251C14.2494 25.9345 14.2888 25.3045 14.4857 24.7533Z"
        fill="white"
      />
      <path
        d="M42.9521 8.17695L39.6842 5.73584L37.8337 7.11389L36.4163 8.17695V12.2717H42.9521V8.17695Z"
        fill="white"
      />
      <path d="M30.8254 22.3516V24.1627L43.8184 27.4306V25.5801L30.8254 22.3516Z" fill="white" />
      <path
        d="M30.8255 22.3513V5.65723C30.1955 5.65723 29.5262 5.73596 28.9356 5.89345L19.7617 8.17708C19.1318 8.33457 18.5018 8.41332 17.8718 8.41332V22.3513C18.7774 22.3513 19.683 22.7056 20.3917 23.375C20.7854 23.7687 21.1004 24.2412 21.2579 24.753C21.4548 25.3436 21.4941 25.9342 21.376 26.5641C21.2579 27.2335 20.9035 27.8634 20.3917 28.3753L17.8718 30.8951V44.1638C18.5018 44.1638 19.1711 44.085 19.7617 43.9275L28.9356 41.6439C29.5655 41.4864 30.1955 41.4077 30.8255 41.4077V24.2018V22.3513Z"
        fill="#1C85E8"
      />
      <path
        d="M21.2973 26.5251L30.8255 24.1627V22.3516L21.1792 24.7533C21.3761 25.3045 21.4154 25.9345 21.2973 26.5251Z"
        fill="#8DC2F3"
      />
    </svg>
  );
};

export default ServiceAreaIcon;
